import el from "@cypherpotato/el";

export function CardGrid(...cards) {
    return el("div.card-grid",
        ...cards
    );
}

export function Card(...children) {
    return el("div.card",
        ...children
    )
}

export function CardHeader(title, subtitle) {
    return el("div.card-header",
        el("h3", title),
        subtitle && el("p", subtitle)
    );
}

export function CardNavigation(...children) {
    return el("div.card-header",
        ...children
    );
}

export function CardContent(...children) {
    return el("div.card-content",
        ...children
    );
}